import React, { useEffect, Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserBalance } from "./redux/actions/coinDBAction";
import { getWebsite } from "./redux/actions/websiteDBAction";
import createSocketClient from "./redux/helpers/socket";
import {
  GET_COIN_DATA,
  GET_CURRENCY_DATA,
  SET_BUY_ORDER_BOOK,
  SET_PAIRED_CURRENCY_PRICE,
  SET_SELL_ORDER_BOOK,
  SET_TRADE_HISTORY,
} from "./redux/constant";
import { N_getProfile } from "./redux/helpers/api_functions_new";
import { parseCmcUpdatedPayload } from "../workers/cmcUpdatedParseClient";
import {
  notifyFutureTradesChanged,
  notifyPositionCreated,
  notifyPositionUpdated,
} from "../utils/futureEvents";
import {
  notifyAssetPriceUpdated,
  notifySpotOrdersChanged,
} from "../utils/tradingEvents";
import PreLoader from "./components/PreLoader";

const Login = lazy(() => import("./Login"));
const Register = lazy(() => import("./Register"));
const Index = lazy(() => import("./Index"));
const Forget = lazy(() => import("./Forget"));
const FOTP = lazy(() => import("./FOTP"));
const UpdatePassword = lazy(() => import("./UpdatePassword"));
const Exchange = lazy(() => import("./Exchange"));
const Future = lazy(() => import("./Future"));
const UserProfile = lazy(() => import("./UserProfile"));
const Wallet = lazy(() => import("./Wallet"));
const GetNotifi = lazy(() => import("./Notification"));
const PrivacyControl = lazy(() => import("./PrivacyControl"));
const Cupon = lazy(() => import("./Cupon"));
const UpcomingProgram = lazy(() => import("./UpcomingProgram"));
const MobileVerification = lazy(() => import("./MobileVerification"));
const About = lazy(() => import("./HomeComp/About"));
const Banner2 = lazy(() => import("./HomeComp/Banner2"));
const Markets = lazy(() => import("./HomeComp/markets"));
const FeedbackForm = lazy(() => import("./HomeComp/FeedbackForm"));
const AccountSecurity = lazy(() => import("./AccountSecurity"));
const KYCVerification = lazy(() => import("./KYCVerification"));
const StepperP2P = lazy(() => import("./p2pPages/AddPostStepper"));
const PaymentMethod = lazy(() => import("./p2pPages/PaymentMethod"));
const AdvertiserTerms = lazy(() => import("./p2pPages/AdvertiserTerms"));
const BankTransfer = lazy(() => import("./p2pPages/payment-methods/BankTransfer"));
const CreateOrderStep = lazy(() => import("./p2pPages/CreateOrderStepper"));
const Privacy = lazy(() => import("./HomeComp/Privacy"));
const TermsConditions = lazy(() => import("./HomeComp/Terms&Conditions"));
const Riskandwaring = lazy(() => import("./HomeComp/Risk&Warning"));
const Education = lazy(() => import("./HomeComp/blogs/Educations"));
const Security_page = lazy(() => import("./HomeComp/Security"));
const FundingMain = lazy(() => import("./fundingMain"));
const AssetsWithdraw = lazy(() => import("./AssetsWithdraw"));
const AssetsDeposit = lazy(() => import("./AssetsDeposit"));
const AssetsFuture = lazy(() => import("./AssetsFuture"));
const AccountVerification = lazy(() => import("./AccountVerification"));
const SpotOrders = lazy(() => import("./SpotOrders"));
const FutureHistory = lazy(() => import("./FutureHistory"));
const PositionHistory = lazy(() => import("./PositionHistory"));
const Transactionbuysell = lazy(() => import("./Transactionbuysell"));
const P2phistory = lazy(() => import("./P2phistory"));
const p2pOrder = lazy(() => import("./p2pOrder"));
const PageNotFound = lazy(() => import("./PageNotFound"));
const ReferPage = lazy(() => import("./referAndEarn/ReferPage"));
const MyAds = lazy(() => import("./myAds"));
const MyOrders = lazy(() => import("./myAds/myorders"));
const OrderChat = lazy(() => import("./myAds/orderChat"));
const ActiveRequests = lazy(() => import("./p2pPages/active-requests"));
const EarnPage = lazy(() => import("./earn/EarnPage"));
const ForexTrading = lazy(() => import("./forex-trading/ForexTrading"));
const Web3 = lazy(() => import("./web3/Web3"));
const EducationDetails = lazy(() => import("./HomeComp/Education-details"));
const AmexaCommunity = lazy(() => import("./AmexaCommunity"));
const AmexaTradingView = lazy(() => import("./Amexa-TradingView"));
const Commingsoon = lazy(() => import("./components/commingsoon"));
const ReferralDetail = lazy(() => import("./referAndEarn/ReferralDetail"));
const CustomerSuppport = lazy(() => import("./CustomerSupport"));
const Guide = lazy(() => import("./Guide"));
const LeagleForm = lazy(() => import("./HomeComp/LeagleForm"));
// const ConvertCurrency = lazy(() => import("./convert"));

export default function Router(props) {
  const dispatch = useDispatch();
  const { isLoggedIn, switch_theme, user } = useSelector(
    (state) => state.AuthReducer
  );

  useEffect(() => {
    dispatch(getWebsite());
  }, [dispatch]);

  useEffect(() => {
    const socket = createSocketClient("kujgwvfq-a-ghosttown-z-1fhhup0p6");
    const activeUserId = isLoggedIn
      ? user?.params
        ? user.params.user_id
        : user?.user_id
      : null;

    const joinFutureRoom = () => {
      if (activeUserId && socket.connected) {
        socket.emit("join", "future_trade");
      }
    };

    const handleCmcUpdated = (res) => {
      parseCmcUpdatedPayload(res)
        .then(({ coins, pairedPrices, error }) => {
          try {
            if (error && error !== "empty") {
              console.log(error);
            }
            const filteredData = Array.isArray(coins) ? coins : [];
            if (filteredData.length > 0) {
              dispatch({
                type: GET_COIN_DATA,
                data: filteredData,
                coin_loading: false,
              });
              dispatch({
                type: SET_PAIRED_CURRENCY_PRICE,
                data: pairedPrices || {},
              });
              notifyAssetPriceUpdated({
                coins: filteredData,
                pairedPrices: pairedPrices || {},
              });
            }

            dispatch({
              type: GET_CURRENCY_DATA,
              data: { currency_coin: Date.now(), currency_price: 2 },
            });
          } catch (err) {
            console.log(err);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const handleBuyOrderUpdated = (res) => {
      dispatch({
        type: SET_BUY_ORDER_BOOK,
        data: res,
        order_book_loading: false,
      });
      notifySpotOrdersChanged(res);
    };

    const handleSellOrderUpdated = (res) => {
      dispatch({
        type: SET_SELL_ORDER_BOOK,
        data: res,
        order_book_loading: false,
      });
      notifySpotOrdersChanged(res);
    };

    const handleOrderHistoryUpdated = (res) => {
      dispatch({ type: SET_TRADE_HISTORY, data: res, trade_loading: false });
      notifySpotOrdersChanged(res);
    };

    const handleBalanceUpdated = (payload) => {
      if (!activeUserId) return;
      if (
        payload?.user_id &&
        String(payload.user_id) !== String(activeUserId)
      ) {
        return;
      }
      dispatch(getUserBalance(activeUserId));
      window.dispatchEvent(
        new CustomEvent("balance-updated", { detail: payload })
      );
    };

    const handleFutureTradeUpdated = (data) => {
      notifyFutureTradesChanged(data);
    };

    const handlePositionCreated = (data) => {
      notifyPositionCreated(data);
    };

    const handlePositionUpdated = (data) => {
      notifyPositionUpdated(data);
    };

    socket.on("connect", joinFutureRoom);
    socket.on("cmc_updated", handleCmcUpdated);
    socket.on("buy_order_updated", handleBuyOrderUpdated);
    socket.on("sell_order_updated", handleSellOrderUpdated);
    socket.on("order_history_updated", handleOrderHistoryUpdated);
    socket.on("BALANCE_UPDATED", handleBalanceUpdated);
    socket.on("updated_future_trade", handleFutureTradeUpdated);
    socket.on("POSITION_CREATED", handlePositionCreated);
    socket.on("POSITION_UPDATED", handlePositionUpdated);

    if (socket.connected) {
      joinFutureRoom();
    }

    return () => {
      socket.off("connect", joinFutureRoom);
      socket.off("cmc_updated", handleCmcUpdated);
      socket.off("buy_order_updated", handleBuyOrderUpdated);
      socket.off("sell_order_updated", handleSellOrderUpdated);
      socket.off("order_history_updated", handleOrderHistoryUpdated);
      socket.off("BALANCE_UPDATED", handleBalanceUpdated);
      socket.off("updated_future_trade", handleFutureTradeUpdated);
      socket.off("POSITION_CREATED", handlePositionCreated);
      socket.off("POSITION_UPDATED", handlePositionUpdated);
      if (socket.connected) {
        socket.emit("leave", "future_trade");
      }
      socket.disconnect();
    };
  }, [isLoggedIn, user, dispatch]);

  function getProfile() {
    dispatch(getUserBalance(user?.params ? user.params.user_id : user.user_id));
    N_getProfile(user?.params ? user.params.user_id : user.user_id)
      .then((d) => {
        if (d.status === 200) {
          dispatch({ type: "PROFILE", data: d?.params.profile_info });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  useEffect(() => {
    if (isLoggedIn && user?.params ? user.params.user_id : user.user_id)
      getProfile();
  }, [isLoggedIn && user?.params ? user.params.user_id : user.user_id]);

  useEffect(() => {
    if (switch_theme == "dark") {
      localStorage.removeItem("tradingview.current_theme.name");
      const body = document.getElementsByTagName("body")[0];
      body?.classList.add("is_dark");
      body?.classList.remove("is_light");

      var icon = document.querySelector("#theme_icon");
      icon?.classList.add("fa-moon");
      icon?.classList.remove("fa-sun");
    } else {
      localStorage.removeItem("tradingview.current_theme.name");
      const body = document.getElementsByTagName("body")[0];
      body?.classList.add("is_light");
      body?.classList.remove("is_dark");

      var icon = document.querySelector("#theme_icon");
      icon?.classList.add("fa-sun");
      icon?.classList.remove("fa-moon");
    }
  }, []);

  const routeFallback = (
    <div role="status" aria-live="polite" aria-busy="true">
      <span className="sr-only">Loading page…</span>
      <PreLoader />
    </div>
  );

  return (
    <Suspense fallback={routeFallback}>
    <Switch>
      <Route exact path="/" component={Index} />
      <Route exact path="/ref/:id?" component={Index} />
      <Route exact path="/login" component={Login} />
      <Route exact path="/news-letter" component={Banner2} />
      <Route path="/create" component={Register} />
      <Route
        exact
        path="/forget"
        render={(props) =>
          !isLoggedIn ? <Forget {...props} /> : <Redirect to="/" />
        }
      />
      <Route
        exact
        path="/forget-password"
        render={(props) =>
          !isLoggedIn ? <FOTP {...props} /> : <Redirect to="/" />
        }
      />
      <Route path="/update-password" component={UpdatePassword} />
      <Route path="/exchange/:id?" component={Exchange} />
      <Route path="/perpetual/:id?" component={Future} />
      <Route path="/P2PPostAd" component={StepperP2P} />
      <Route path="/payment-method" component={PaymentMethod} />
      <Route path="/advertisers-terms" component={AdvertiserTerms} />
      <Route path="/bank-transfer" component={BankTransfer} />
      <Route
        path="/profile"
        render={(props) =>
          isLoggedIn ? <UserProfile {...props} /> : <Redirect to="/login" />
        }
      />
      <Route path="/notification" component={GetNotifi} />
      <Route path="/privacy_control" component={PrivacyControl} />
      <Route path="/coupan" component={Cupon} />
      <Route path="/upcoming_program" component={UpcomingProgram} />
      <Route path="/mobile-verify/:action?" component={MobileVerification} />
      <Route path="/kyc-verify" component={KYCVerification} />
      <Route
        path="/wallet"
        render={(props) =>
          isLoggedIn ? <Wallet {...props} /> : <Redirect to="/login" />
        }
      />
      <Route path="/about" component={About} />
      <Route path="/privacy" component={Privacy} />
      <Route path="/terms_&_conditions" component={TermsConditions} />
      <Route path="/education" component={Education} />
      <Route path="/education-details/:id" component={EducationDetails} />
      <Route path="/feedback" component={FeedbackForm} />
      <Route path="/customer-support" component={CustomerSuppport} />
      <Route path="/guide" component={Guide} />
      <Route path="/legal" component={LeagleForm} />


      <Route path="/risk_&_warning" component={Riskandwaring} />
      <Route path="/security_data" component={Security_page} />
      <Route path="/markets" component={Markets} />
      <Route path={"/earn"} component={EarnPage} />
      <Route path={"/forex-trading"} component={ForexTrading} />
      <Route path={"/web3"} component={Web3} />
      <Route path={"/amexa-community"} component={AmexaCommunity} />
      <Route path={"/amexa-referral-program"} component={ReferralDetail} />
      <Route path={"/amexa-trading-view"} component={AmexaTradingView} />
      <Route
        path="/FundingAccount"
        render={(props) =>
          isLoggedIn ? <FundingMain {...props} /> : <Redirect to="/login" />
        }
      />
      <Route
        path="/AssetsWithdraw"
        render={(props) =>
          isLoggedIn ? <AssetsWithdraw {...props} /> : <Redirect to="/login" />
        }
      />
      <Route
        path="/AssetsDeposit"
        render={(props) =>
          isLoggedIn ? <AssetsDeposit {...props} /> : <Redirect to="/login" />
        }
      />
      <Route
        path="/AssetsFuture"
        render={(props) =>
          isLoggedIn ? <AssetsFuture {...props} /> : <Redirect to="/login" />
        }
      />
      <Route
        path="/copy-trading"
        render={(props) =>
          isLoggedIn ? <AssetsFuture {...props} /> : <Redirect to="/login" />
        }
      />
      <Route
        path="/AccountSecurity"
        render={(props) =>
          isLoggedIn ? <AccountSecurity {...props} /> : <Redirect to="/login" />
        }
      />
      <Route
        path="/AccountVerification"
        render={(props) =>
          isLoggedIn ? (
            <AccountVerification {...props} />
          ) : (
            <Redirect to="/login" />
          )
        }
      />
      <Route
        path="/SpotOrders"
        render={(props) =>
          isLoggedIn ? <SpotOrders {...props} /> : <Redirect to="/login" />
        }
      />
      <Route path="/FutureHistory" render={(props)=> isLoggedIn ? <FutureHistory {...props} /> : <Redirect to="/login" />} />
      <Route path="/PositionHistory" render={(props)=> isLoggedIn ? <PositionHistory {...props} /> : <Redirect to="/login" />} />
      <Route
        path="/transaction"
        render={(props) =>
          isLoggedIn ? (
            <Transactionbuysell {...props} />
          ) : (
            <Redirect to="/login" />
          )
        }
      />
      <Route
        path="/p2p-history"
        render={(props) =>
          isLoggedIn ? (
            <P2phistory {...props} />
          ) : (
            <Redirect to="/login" />
          )
        }
      />
      <Route path={"/p2pOrder"} component={p2pOrder} />
      <Route path={"/PageNotFound"} component={PageNotFound} />
      <Route path={"/referal"} component={ReferPage} />

      {/* Convert */}
      {/* <Route path={"/convert"} component={ConvertCurrency} /> */}

      {/* My Ads */}
      <Route
        path="/my-postad"
        render={(props) =>
          isLoggedIn ? <MyAds {...props} /> : <Redirect to="/login" />
        }
      />
      <Route
        path="/active-requests"
        render={(props) =>
          isLoggedIn ? <ActiveRequests {...props} /> : <Redirect to="/login" />
        }
      />
      <Route
        path="/order-chat"
        render={(props) =>
          isLoggedIn ? <OrderChat {...props} /> : <Redirect to="/login" />
        }
      />

      {/* Create Order */}
      <Route
        path="/create-order"
        render={(props) =>
          isLoggedIn ? <CreateOrderStep {...props} /> : <Redirect to="/login" />
        }
      />

      {/* My Orders */}
      <Route
        path="/my-orders"
        render={(props) =>
          isLoggedIn ? <MyOrders {...props} /> : <Redirect to="/login" />
        }
      />
      <Route path="*" render={(props) => <Commingsoon />} />
    </Switch>
    </Suspense>
  );
}
